import ApiCalls from "../util/ApiCalls";

class JourneyQuestionService {
    async getByGoal(goalId) {
        return ApiCalls.defaultGet("/journey/" + goalId + "/questions", {});
      }
}
  
export default new JourneyQuestionService();